import Layout from "./components/shared/Layout";

function App() {
  return (
    <Layout />
  );
}

export default App;
